export const campusLifeItems = [
  {
    slug: "hostels",
    title: "Hostels",
    short: "Hostels",
    image: "https://images.pexels.com/photos/12091126/pexels-photo-12091126.jpeg?w=2400",
    overview:
      "KLS VDIT provides hostel facilities that support a safe, disciplined and comfortable residential environment for students. The facilities are intended to help students focus on academics while participating fully in campus life.",
    sections: [
      {
        id: "facilities",
        title: "Facilities and Amenities",
        items: [
          "Separate boys' and girls' hostel facilities.",
          "Well-furnished rooms and essential residential amenities.",
          "Campus environment that supports academic focus and student development.",
        ],
      },
      {
        id: "safety",
        title: "Student Safety and Discipline",
        items: [
          "Hostel administration supports discipline, safety and student welfare.",
          "Wardens and support staff help maintain a responsible residential atmosphere.",
        ],
      },
      {
        id: "dining",
        title: "Dining and Accommodation",
        items: [
          "Mess and dining information will be updated with official details.",
          "Accommodation capacity and admission details will be updated.",
        ],
      },
    ],
    quickFacts: [
      ["Category", "Campus Life"],
      ["Facility", "Hostels"],
      ["Availability", "To be updated"],
      ["Contact", "To be updated"],
    ],
  },
  {
    slug: "transportation",
    title: "Transportation",
    short: "Transport",
    image: "https://images.pexels.com/photos/5805182/pexels-photo-5805182.jpeg?w=2400",
    overview:
      "The college transport facility supports day scholars with convenient connectivity between the campus, Haliyal, Dandeli and surrounding areas.",
    sections: [
      {
        id: "coverage",
        title: "Bus Routes and Coverage",
        items: [
          "College buses connect the campus with Haliyal, Dandeli and nearby areas.",
          "Detailed bus routes and stop-wise schedules will be updated.",
        ],
      },
      {
        id: "commute",
        title: "Student Commute Support",
        items: [
          "The facility helps students commute comfortably and reliably.",
          "Transport support is planned around regular academic schedules.",
        ],
      },
      {
        id: "safety",
        title: "Safety and Convenience",
        items: [
          "Transport operations prioritize student convenience and timely commute.",
          "Transport contact details will be updated with official information.",
        ],
      },
    ],
    quickFacts: [
      ["Category", "Campus Life"],
      ["Facility", "Transportation"],
      ["Routes", "To be updated"],
      ["Contact", "To be updated"],
    ],
  },
  {
    slug: "sports-gym",
    title: "Sports & Gym",
    short: "Sports",
    image: "https://images.unsplash.com/photo-1607013407627-6ee814329547?w=2400&q=80",
    subtitle: "Department of Physical Education & Sports",
    intro:
      "The institute encourages students to participate in VTU Belagavi Division, inter-collegiate and state-level competitions. Students regularly represent the institution in athletics, cricket, football, volleyball, basketball, kabaddi, kho-kho, table tennis, badminton, karate, wrestling, judo, netball and throwball. The institute also hosts selected VTU-level tournaments on its campus.",
    overview:
      "KLS VDIT Haliyal provides comprehensive gym, indoor and outdoor sports facilities to support the physical fitness, well-being and competitive development of students. The Department of Physical Education and Sports coordinates all sports activities under the guidance of Shri. G. S. Yallur, Physical Education Director.",
    overviewItems: [
      "Indoor sports facilities include a 12-station multi-gym, table tennis area, wrestling and judo facility, yoga hall, chess and carrom facilities, and fitness equipment near the girls' hostel.",
      "Outdoor facilities support football, cricket, athletics, kabaddi, volleyball, handball, basketball, netball, throwball, kho-kho and ball badminton.",
      "The institute has approximately 14,000 square metres of total outdoor ground area, including around 12,000 square metres for football, cricket, athletics and kabaddi.",
      "Students participate regularly in VTU divisional and state-level sports competitions.",
      "KLS VDIT has also organized tournaments in table tennis, basketball, kho-kho and other sports.",
    ],
    sections: [
      {
        id: "sports-faculty",
        title: "Sports Faculty",
        type: "table",
        columns: ["Role", "Name", "Qualification", "Experience"],
        rows: [
          // ["Physical Education Director", "Shri. G. S. Yallur", "M.P.Ed, K-SET", "Fifteen Years"],
          ["Supporting Staff", "Mr. Fakerappa I T", "S.S.L.C", "Seven Years"],
        ],
      },
      {
        id: "sports-achievement",
        title: "Achievement",
        type: "achievements",
        years: [
          {
            year: "2025-26",
            summary:
              "KLS VDIT actively participated in and organized several VTU Belagavi Division sports tournaments during the academic year 2025-26.",
            events: [
              "26th VTU Inter Collegiate State Level Athletic Meet 2024-25 at JNNCE Shivamogga from 14th to 19th March 2025.",
              "VTU Belagavi Division Inter Collegiate Cricket Men Tournament at SDM CET Dharwad from 24th to 28th March 2025.",
              "VTU Belagavi Division Inter Collegiate Football Men Tournament at KLS GIT Belagavi on 2nd April 2025.",
              "VTU Belagavi Division Kabaddi Men Tournament at VSMSRKIT Nipani on 11th and 12th April 2025.",
              "VTU Belagavi Division Inter Collegiate Volleyball Men Tournament at SKSVMA CET Laxmeshwar on 22nd and 23rd April 2025.",
              "VTU Belagavi Division Inter Collegiate Kho-Kho Men Tournament held at KLS VDIT Haliyal on 29th and 30th April 2025; Men team Runner Up / secured 2nd place.",
              "VTU Belagavi Division Shuttle Badminton Tournament at VTU Campus Belagavi on 8th and 9th September 2025.",
              "VTU State Level Shuttle Badminton Tournament at PES Mandya on 11th and 12th September 2025.",
              "VTU Belagavi Division Table Tennis Men & Women Tournament held at KLS VDIT Haliyal on 15th and 16th September 2025; Men and Women team Runner Up.",
              "VTU State Level Table Tennis Men & Women Tournament held at BMS Bengaluru on 21st and 23rd September 2025.",
              "VTU State Level Wrestling & Judo Men and Women Competition held at MIT Mysuru from 17th to 19th October 2025.",
              "VTU State Level Karate Men Competition held at RVIT Bengaluru on 31st October 2025.",
              "VTU Belagavi Division Basketball Men Tournament held at KLS VDIT Haliyal on 7th and 8th November 2025.",
              "VTU State Level Powerlifting Men Competition held at RVIT Bengaluru on 7th and 8th November 2025.",
            ],
            highlights: [
              "Kho-Kho Men team secured 2nd place in VTU Belagavi Division Inter Collegiate Kho-Kho Tournament held at KLS VDIT Campus from 29th to 30th April 2025.",
              "Shuttle Badminton Men team secured 2nd place in VTU Belagavi Division Inter Collegiate Shuttle Badminton Tournament held at VTU Campus Belagavi from 8th to 9th September 2025.",
              "Table Tennis Men & Women team secured 2nd place in VTU Belagavi Division Inter Collegiate Table Tennis Tournament held at KLS VDIT Campus.",
              "Wrestling & Judo participants secured silver and bronze medals at the VTU State Level competition held at MIT Mysuru.",
              "Karate Men participants secured bronze medals at the VTU State Level competition held at RVIT Bengaluru.",
            ],
          },
          {
            year: "2024",
            summary:
              "Students participated in various indoor and outdoor games conducted by VTU Belagavi Division and State level tournaments including table tennis, karate, wrestling, athletics, and cricket.",
            events: [
              "VTU Belagavi Division Table Tennis Tournament Men & Women 2024.",
              "VTU Belagavi Division Basketball Men Tournament 2024.",
              "VTU Rest of Bengaluru Division Inter Collegiate Basketball Women Tournament 2024.",
            ],
            highlights: [
              "Table Tennis Women team secured 2nd place in VTU Belagavi Division Inter Collegiate Table Tennis Tournament held at KLS VDIT Campus from 1st to 2nd July 2024 and qualified for state level at VVCE Mysuru on 18th and 19th July 2024.",
              "Karate Men team participated in VTU State Level Inter Collegiate Karate Competition at BIT Bengaluru from 26th September 2024; Vinayak M B secured 3rd place in 60 kg and Pancham S S secured 3rd place in 84 kg.",
              "Kabaddi Men team secured 2nd place in VTU Belagavi Division Inter Collegiate Kabaddi Tournament held at VSMSRKIT Nipani from 18th to 19th October 2024 and qualified for state level at CIT Gubbi from 23rd to 25th October 2024.",
              "Basketball Women team secured 4th place in VTU Rest of Bengaluru Division Inter Collegiate Basketball Tournament held at KLS VDIT Campus from 5th to 6th November 2024 and qualified for state level at RVIT Bengaluru from 7th to 9th November 2024.",
              "Volleyball Men team secured 2nd place in VTU Belagavi Division Inter Collegiate Volleyball Tournament held at TCE Gadag from 19th to 20th November 2024 and qualified for state level at MIT Mysuru.",
            ],
          },
          {
            year: "2023",
            summary:
              "Students participated in various indoor and outdoor games conducted by VTU Division and State level tournaments including table tennis, karate, netball, wrestling, athletics, and cricket.",
            events: [
              "KLS VDIT organized VTU State Level Inter Collegiate Wrestling & Judo Men & Women Competition and selection trials for 2023-24 from 19th to 21st November 2023.",
            ],
            highlights: [
              "Throw Ball Women team secured 4th place in VTU Belagavi Division Inter Collegiate Throw Ball Tournament held at SKSVMA CET Laxmeswar from 13th to 14th March 2023.",
              "Kho-Kho Men team won 2nd place in VTU Belagavi Division Inter Collegiate Kho-Kho Tournament held at HIT Nidasoshi on 20th and 21st March 2023, and participated in state level competition at KIT Tiptur on 24th and 25th March 2023.",
              "Net Ball Men team participated in VTU Rest of Bengaluru Division Inter Collegiate Net Ball Tournament held at St. Joseph Engineering College, Mangalore on 29th March 2023.",
            ],
          },
        ],
        groups: [
          {
            title: "2025-26 Kho-Kho Men - Runner Up",
            columns: ["Name", "USN", "Semester"],
            rows: [
              ["Mr. Md Yasin Baig M S", "2VD22EC404", "8th"],
              ["Mr. Sachin S Naikar", "2VD22CS043", "6th"],
              ["Mr. Maruti B Goudar", "2VD22EE021", "6th"],
              ["Mr. Gangadhar Hongal", "2VD22EC038", "6th"],
              ["Mr. Akshay Sheelimath", "2VD22EC012", "6th"],
              ["Mr. Dileep B Walekar", "2VD22EE013", "6th"],
              ["Mr. Chetan S Ghadi", "2VD24CV406", "4th"],
              ["Mr. Prajwal Pawar", "2VD23EE028", "4th"],
              ["Mr. Rushikesh Shinde", "2VD23ME414", "6th"],
              ["Mr. Nikhil Mirajakar", "2VD23EC056", "4th"],
              ["Mr. Girish Hadapad", "2VD23EE011", "4th"],
              ["Mr. Shrishail Warad", "2VD24EE048", "2nd"],
              ["Mr. Manesh M V", "2VD24CS048", "2nd"],
              ["Mr. Agadish Kedari Chipati", "2VD23ME408", "6th"],
              ["Mr. Praveen Dhanaji Kadam", "2VD23EE031", "4th"],
            ],
          },
          {
            title: "2025-26 Medal Winners - Wrestling, Judo and Karate",
            columns: ["Name", "Event / Category", "USN", "Semester"],
            rows: [
              ["Mr. Shanamukh C G", "Wrestling 74 kg - Silver medal", "2VD24ME444", "5th"],
              ["Mr. Ekanath T B", "Wrestling 61 kg - Bronze medal", "2VD25EC050-T", "1st /2nd"],
              ["Miss. Aishwarya H M", "Wrestling 53 kg - Bronze medal", "2VD24EE400", "5th"],
              ["Mr. Pancham S S", "Karate 84 kg - Bronze medal", "2VD23CI026", "5th"],
              ["Mr. Malik Rehan Kittur", "Karate 67 kg - Bronze medal", "2VD26CV403", "3rd"],
            ],
          },
          {
            title: "2024 Major Winners",
            columns: ["Achievement", "Student / Team", "Details"],
            rows: [
              ["Table Tennis Women - 2nd place", "Sanjana S.S, Sneha S M, Priya M H, Amrita M O", "Qualified for state level at VVCE Mysuru."],
              ["Karate Men - 3rd place", "Vinayak M B", "60 kg category at BIT Bengaluru."],
              ["Karate Men - 3rd place", "Pancham S S", "84 kg category at BIT Bengaluru."],
              ["Kabaddi Men - 2nd place", "KLS VDIT Kabaddi Men Team", "Qualified for state level at CIT Gubbi."],
              ["Basketball Women - 4th place", "KLS VDIT Basketball Women Team", "Qualified for state level at RVIT Bengaluru."],
              ["Volleyball Men - 2nd place", "KLS VDIT Volleyball Men Team", "Qualified for state level at MIT Mysuru."],
            ],
          },
          {
            title: "2023 Major Teams",
            columns: ["Sport", "Result / Participation", "Students"],
            rows: [
              ["Throw Ball Women", "4th place", "Queeni F, Veena S, Tunga R, Sakshi D, Priya H, Poorvi V, Anusha G, Mamatha L, Laxmi C, Jahanvi M, Soniya C, Sahitya S"],
              ["Kho-Kho Men", "2nd place and state level participation", "Tirumal R M, Raghunath M D, Dileep B G, Malatesh S M, Nikil B C, Shashank N, Gangadhar H, Akshay S, Sumit G R, Deelip W, Maruti B G, Sachin S N"],
              ["Net Ball Men", "VTU Rest of Bengaluru Division participation", "Anirudh Patil, Abhishek V, Samarth S K, Sujal C Akki, Nuthan K B, Rajesh S Meti, Mhd Hujefa S K, Shivaprasad D K, Sheetal B Patil, Nandana S H, Praveen K, Vinayak S G"],
            ],
          },
        ],
        galleryNotes: [
          "Sports gallery photos from the reports are not available as separate web-ready image assets yet.",
          "Gallery can be added once the client provides separate images for teams and events.",
        ],
      },
    ],
    quickFacts: [
      ["Category", "Campus Life"],
      ["Facility", "Sports & Gym"],
      ["Department", "Physical Education & Sports"],
      ["Physical Education Director", "Shri. G. S. Yallur"],
      ["Indoor Facilities", "5"],
      ["Outdoor Facilities", "8"],
      ["Total Ground Area", "14,000 Sq meters"],
    ],
  },
  {
    slug: "atm",
    title: "ATM",
    short: "ATM",
    image: "/Campus/ATM.jpeg",
    overview:
      "The on-campus ATM facility provides convenient banking access for students, parents, staff and visitors.",
    sections: [
      {
        id: "banking",
        title: "Banking Convenience",
        items: [
          "ATM access supports cash withdrawal and basic banking convenience on campus.",
          "The facility helps reduce the need for students to travel outside campus for routine cash needs.",
        ],
      },
      {
        id: "location",
        title: "Location and Accessibility",
        items: [
          "Exact campus location details will be updated.",
          "Accessibility and operating details will be updated with official information.",
        ],
      },
    ],
    quickFacts: [
      ["Category", "Campus Life"],
      ["Facility", "ATM"],
      ["Location", "To be updated"],
      ["Availability", "To be updated"],
    ],
  },
  {
    slug: "solar-rooftop",
    title: "Solar Rooftop",
    short: "Solar",
    image: "https://images.pexels.com/photos/9875441/pexels-photo-9875441.jpeg?w=2400",
    subtitle: "200 kW On-Grid Rooftop Solar Photovoltaic Plant",
    intro:
      "KLS VDIT has installed a 200 kW grid-connected rooftop solar photovoltaic plant to promote clean energy usage, reduce electricity consumption from the grid, and support environmental sustainability.",
    overview:
      "An on-grid rooftop photovoltaic plant is connected to the utility electricity grid. Solar PV panels convert sunlight into DC electrical energy, which is converted into AC electrical energy using a grid-tied inverter and supplied to connected loads. When solar generation is more than the load requirement, excess energy is exported to the grid through a bidirectional meter. When solar generation is insufficient, power is drawn from the grid.",
    sections: [
      {
        id: "capacity-location",
        title: "Plant Capacity and Location",
        type: "table",
        columns: ["Detail", "Value"],
        rows: [
          ["Total Capacity", "200 kW"],
          ["Main Building Rooftop", "150 kW"],
          ["Mechanical Building Rooftop", "50 kW"],
          ["Commissioned Year", "2018"],
          ["Investment", "Rs. 82 Lakhs"],
          ["Rooftop Area Covered", "2600 square meters"],
        ],
      },
      {
        id: "technical-specifications",
        title: "Technical Specifications",
        type: "table",
        columns: ["Specification", "Value"],
        rows: [
          ["Total Solar PV Panels", "626"],
          ["Panel Capacity", "320 Wp"],
          ["Panel Type", "Poly Crystalline"],
          ["Panel Make", "WAAREE"],
          ["Grid-Tied Inverters", "04 numbers"],
          ["Inverter Capacity", "50 kVA each"],
          ["Inverter Make", "Delta and V-Guard"],
        ],
      },
      {
        id: "equipment",
        title: "Important Equipment",
        items: [
          "DC Distribution Box with Fuses, MCBs and Surge Protection Devices (SPDs)",
          "AC Distribution Box with MCBs",
          "Net Meter or Bidirectional Energy Meter",
          "Earthing Provided",
          "Lightning Arresters Provided",
          "HT Metering Cubical",
        ],
      },
      {
        id: "energy-generation",
        title: "Energy Generation",
        type: "table",
        columns: ["Generation Detail", "Value"],
        rows: [
          ["Daily Average Power Generation", "About 440 units"],
          ["Monthly Average Power Generation", "13,220 units, considering the data of year 2025"],
          ["Total Generation till May 2026", "1,636 MWh"],
          ["Total Units Generated till May 2026", "16,36,228 units"],
        ],
      },
      {
        id: "environmental-impact",
        title: "Environmental Impact",
        type: "table",
        columns: ["Impact Detail", "Value"],
        rows: [
          ["CO2 avoided per unit", "0.85 kg"],
          ["CO2 emission reduction till May 2026", "13,901 tonnes"],
        ],
        note: "Every unit of thermal power consumption produces approximately 0.85 kg of carbon dioxide. Therefore, every unit of solar energy helps prevent approximately 0.85 kg of carbon dioxide emission.",
      },
      {
        id: "benefits",
        title: "Sustainability Benefits",
        items: [
          "Reduces electricity consumption from the grid",
          "Promotes renewable energy adoption",
          "Supports green campus initiatives",
          "Helps reduce carbon dioxide emissions",
          "Improves energy efficiency",
          "Demonstrates institutional commitment to sustainability",
        ],
      },
    ],
    quickFacts: [
      ["Category", "Campus Life"],
      ["Facility", "Solar Rooftop"],
      ["Plant Type", "On-Grid Rooftop Solar PV Plant"],
      ["Total Capacity", "200 kW"],
      ["Commissioned Year", "2018"],
      ["Rooftop Area", "2600 sq. meters"],
      ["Total Panels", "626"],
      ["Total Generation", "1,636 MWh till May 2026"],
      ["CO2 Reduction", "13,901 tonnes till May 2026"],
    ],
  },
];

export const findCampusLifeItem = (slug) =>
  campusLifeItems.find((item) => item.slug === slug);
